import { render, staticRenderFns } from "./ArtworkImage.vue?vue&type=template&id=19372f80&"
import script from "./ArtworkImage.vue?vue&type=script&lang=js&"
export * from "./ArtworkImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports